import 'react-calendar/dist/Calendar.css';
import 'react-datetime-picker/dist/DateTimePicker.css';

import { PageClaimList } from 'pages/claim';
import AnnouncementPage from 'pages/config/announcement';
import { CreateAnnouncementPage } from 'pages/config/announcement/createAnnouncement';
import { EditAnnouncementPage } from 'pages/config/announcement/editAnnouncement';
import { ChangePassword } from 'pages/config/change-password';
import { MaintenanceConfig } from 'pages/config/maintenance/maintenanceConfig';
import { WithdrawConfig } from 'pages/config/withdraw/withdrawConfig';
import { PageExperienceGameList } from 'pages/experience-game';
import PageFranchiseCommissionHistory from 'pages/franchise/commission';
import { PageFranchiseLeaderTable } from 'pages/franchise/leaderTable';
import { PageFranchiseLevelSettingHistory } from 'pages/franchise/level-setting-history';
import { PageFranchiseTable } from 'pages/franchise/table';
import { PageFranchiseTree } from 'pages/franchise/tree';
import { OrdersPage, SupplierListPage } from 'pages/game-management';
import { GameCreatePage } from 'pages/game-management/games/create';
import { GameEditPage } from 'pages/game-management/games/edit';
import { GameListPage } from 'pages/game-management/games/list';
import { SupplierCreatePage } from 'pages/game-management/suppliers/add';
import { SupplierEditPage } from 'pages/game-management/suppliers/edit';
import { OrdersOverviewPage } from 'pages/orders-overview';
import { ReportSystem } from 'pages/report/system';
import { TransactionDetail, TransactionList } from 'pages/transaction';
import { DepositSupport } from 'pages/transaction/deposit-support/DepositSupport';
import { PlaceGameList } from 'pages/transaction/place-game';
import { TransactionDemoList } from 'pages/transaction/transaction-list/TransactionDemoList';
import { WithdrawProgress } from 'pages/transaction/withdraw/WithdrawProgress';
import { TransactionAdminWithdrawList } from 'pages/transaction/withdraw-to-admin-wallet/TransactionAdminWithdrawList';
import { TransferList, TransferToUser } from 'pages/transferOld';
import { PageUserAffiliation } from 'pages/user/affiliation';
import { PageKYC } from 'pages/user/kyc';
import { UserDetail } from 'pages/user/user-detail';
import { UserList } from 'pages/user/user-list';
import ElectricBillPage from 'pages/electric-bill';
import ElectricBillUploadFilePage from 'pages/electric-bill-upload-file';
import TransferToUserPage from 'pages/transfer-to-user';
import TopUpPointsPage from 'pages/top-up-points';
import React, { FC } from 'react';
import BankManagementPage from 'pages/Personal/BankManagement';
import RequestWithdrawOwnPage from 'pages/request-withdraw/request-withdraw-own';
import CreateRequestWithdrawPage from 'pages/request-withdraw/create-request-withdraw';
import RequestWithdrawListPage from 'pages/request-withdraw/check-request-withdraw';
import CheckRequestWithdrawPage from 'pages/request-withdraw/check-request-withdraw';

export const Routes = {
  // dashboard: {
  //     path: '/',
  //     component: PageDashboard,
  // },
  dashboard: {
    path: '/',
    component: UserList,
  },
  userList: {
    path: '/users',
    component: UserList,
  },
  userDetail: {
    path: '/user/:id',
    component: UserDetail,
    renderPath: (id: string) => `/user/${id}`,
  },
  transactionList: {
    path: '/transactions',
    component: TransactionList,
  },
  transactionDetail: {
    path: '/transaction/:id',
    component: TransactionDetail,
    renderPath: (id: string) => `/transaction/${id}`,
  },
  transferList: {
    path: '/transfers',
    component: TransferList,
  },
  TransferToUser: {
    path: '/transfer-to-user',
    component: TransferToUserPage,
  },
  userKYCList: {
    path: '/users/kycs',
    // component: PageUsersKYC,
  },
  userAffiliation: {
    path: '/users/affiliation',
    component: PageUserAffiliation,
  },
  franchiseTable: {
    path: '/franchise',
    component: PageFranchiseTable,
  },
  franchiseTree: {
    path: '/franchise/tree',
    component: PageFranchiseTree,
  },
  franchiseLevelSettingHistory: {
    path: '/franchise/level-setting-history',
    component: PageFranchiseLevelSettingHistory,
  },
  franchiseCommissionHistory: {
    path: '/franchise/commission-history',
    component: PageFranchiseCommissionHistory,
  },
  franchiseLeader: {
    path: '/franchise/leader',
    component: PageFranchiseLeaderTable,
  },
  placeGameList: {
    path: '/transactions/place-game',
    component: PlaceGameList,
  },
  transactionDemoList: {
    path: '/transactions/demo',
    component: TransactionDemoList,
  },
  withdraw: {
    path: '/transactions/withdraws',
    component: WithdrawProgress,
  },
  kyc: {
    path: '/kyc',
    component: PageKYC,
  },
  reportSystem: {
    path: '/reports/system',
    component: ReportSystem,
  },
  depositSupport: {
    path: '/transactions/deposit-support',
    component: DepositSupport,
  },
  TransactionAdminWithdrawList: {
    path: '/transactions/transactions-withdraw-to-admin-wallet',
    component: TransactionAdminWithdrawList,
  },
  withdrawConfig: {
    path: '/server-config/withdraw',
    component: WithdrawConfig,
  },
  maintenanceConfig: {
    path: '/server-config/maintenance',
    component: MaintenanceConfig,
  },
  ChangePassword: {
    path: '/setting/change-password',
    component: ChangePassword,
  },
  ClaimList: {
    path: '/claim',
    component: PageClaimList,
  },
  OrdersOverviewPage: {
    path: '/orders-overview',
    component: OrdersOverviewPage,
    renderPath: (fromDate: string, toDate: string) =>
      `/orders-overview?fromDate=${fromDate}&toDate=${toDate}`,
  },
  OrdersPage: {
    path: '/game-management/orders',
    component: OrdersPage,
  },
  SupplierListPage: {
    path: '/game-management/supplier',
    component: SupplierListPage,
  },
  SupplierCreatePage: {
    path: '/game-management/supplier/create',
    component: SupplierCreatePage,
  },
  SupplierEditPage: {
    path: '/game-management/supplier/edit/:id',
    component: SupplierEditPage,
  },
  GameListPage: {
    path: '/game-management/game',
    component: GameListPage,
  },
  GameCreatePage: {
    path: '/game-management/game/create',
    component: GameCreatePage,
  },
  GameEditPage: {
    path: '/game-management/game/edit/:id',
    component: GameEditPage,
  },
  ExperienceGameList: {
    path: '/experience-game',
    component: PageExperienceGameList,
  },
  Announcement: {
    path: '/server-config/announcement',
    component: AnnouncementPage,
  },
  CreateAnnouncement: {
    path: '/server-config/announcement/create',
    component: CreateAnnouncementPage,
  },
  EditAnnouncement: {
    path: '/server-config/announcement/edit',
    component: EditAnnouncementPage,
  },
  ElectricBill: {
    path: '/electric-bill',
    component: ElectricBillPage,
  },
  ElectricBillUpFile: {
    path: '/electric-bill-upload-file',
    component: ElectricBillUploadFilePage,
  },
  TopUpPoints: {
    path: '/top-up-points',
    component: TopUpPointsPage,
  },
  BankManagement: {
    path: '/personal/bank-management',
    component: BankManagementPage,
  },
  RequestWithdrawOwn: {
    path: '/request-withdraw/request-withdraw-own',
    component: RequestWithdrawOwnPage,
  },
  RequestWithdraw: {
    path: '/request-withdraw',
    component: CheckRequestWithdrawPage,
  },
  CreateRequestWithdraw: {
    path: '/request-withdraw/create-request-withdraw',
    component: CreateRequestWithdrawPage,
  },
  RequestWithdrawList: {
    path: '/request-withdraw/check-request-withdraw',
    component: CheckRequestWithdrawPage,
  },
};

export const AppRoutes: FC = () => {
  return <></>;
};
